export default __webpack_public_path__ + "static/media/greygenetics.d8f09347.png";